<template>
  <vx-card v-if="project">
    <div class="gw-cab">
      <div class="gw-cab-identidad">
        <h1 class="gw-cab-nombre">{{ nombre }}</h1>
        <p class="gw-cab-persona">
          <template v-if="cedula">Cédula {{ cedula }}</template>
          <template v-if="cedula && cargo"> · </template>
          <template v-if="cargo">{{ cargo }}</template>
        </p>

        <!-- Lo que el encabezado tiene que responder de un vistazo: en qué
             estado está y cuánto lleva. Antes solo decía "Finalizado: Aún no
             finaliza", que no es ninguna de las dos cosas. -->
        <div class="gw-cab-estado" v-if="resumenEstado">
          <span class="gw-cab-chip" :class="'gw-cab-chip--' + resumenEstado.tono">
            {{ resumenEstado.estado }}
          </span>
          <span class="gw-cab-detalle">{{ resumenEstado.detalle }}</span>
          <span v-if="project.quality" class="gw-cab-calidad" :title="tituloCalidad">
            Verificado por calidad
          </span>
        </div>
      </div>

      <div class="gw-cab-logo" v-if="clientLogo">
        <img :src="clientLogo" alt="" />
      </div>
    </div>

    <!-- Los datos de contexto, como pares etiqueta/valor y no como filas
         sueltas con etiquetas en negrita repartidas por el ancho. -->
    <div class="gw-cab-datos gw-det-kv">
      <div v-for="(dato, i) in datos" :key="i">
        <div class="gw-det-label">{{ dato.etiqueta }}</div>
        <div class="gw-det-value">{{ dato.valor }}</div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: "ProjectHeader",
  props: {
    project: Object,
    userInfo: Object,
  },

  data() {
    return {
      clientLogo: "",
      tituloCalidad: "Este proceso lo revisó el equipo de calidad de Globalwork.",
    };
  },

  computed: {
    basicos() {
      return (this.project || {}).data_basic || {};
    },

    nombre() {
      return this.basicos.person_full_name || "";
    },

    cedula() {
      return this.basicos.person_id || "";
    },

    cargo() {
      return this.basicos.current_activity || "";
    },

    // Estado y tiempo transcurrido. Los días son de calendario y se dice así
    // ("desde que se creó"): el ANS se mide en días hábiles y está en el
    // bloque de tiempos, justo debajo. Mezclar las dos unidades sin decirlo
    // es lo que hace que un número no se pueda defender.
    resumenEstado() {
      var p = this.project || {};
      var db = this.basicos;
      if (!db.status_name && !p.status_name) return null;

      var entregado = this.primeraLinea(db.delivered_at);
      var finalizado = entregado && entregado !== "Aún no finaliza";

      if (finalizado) {
        var dias = db.response_days;
        var detalle = "entregado el " + entregado;
        if (dias !== "" && dias != null) {
          detalle += " · tomó " + dias + (dias === 1 ? " día" : " días");
        }
        return { estado: p.status_name || db.status_name, detalle: detalle, tono: "ok" };
      }

      var corridos = this.diasDesde(p.created_at);
      return {
        estado: p.status_name || db.status_name,
        detalle:
          corridos == null
            ? "todavía no finaliza"
            : "lleva " + corridos + (corridos === 1 ? " día" : " días") +
              " desde que se creó",
        tono: "curso",
      };
    },

    datos() {
      var p = this.project || {};
      var db = this.basicos;
      var tipo = [p.project_type_name, p.poly_type_name].filter(Boolean).join(" · ");

      return [
        { etiqueta: "Tipo de proceso", valor: tipo || "—" },
        { etiqueta: "Creado el", valor: this.enLinea(db.created_at) || "—" },
        { etiqueta: "Creado por", valor: db.client_user_name || "—" },
        { etiqueta: "Ciudad", valor: db.city_name || "—" },
        { etiqueta: "Entregado el", valor: this.enLinea(db.delivered_at) || "—" },
      ];
    },
  },

  methods: {
    primeraLinea(valor) {
      return valor == null ? null : String(valor).split("\n")[0].trim();
    },

    enLinea(valor) {
      return valor == null ? null : String(valor).replace(/\s*\n\s*/g, " ").trim();
    },

    diasDesde(iso) {
      if (!iso) return null;
      var d = new Date(String(iso).replace(" UTC", "Z").replace(" ", "T"));
      if (isNaN(d.getTime())) return null;
      return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));
    },

    activeUserImg() {
      if (this.userInfo != undefined) {
        var photoUrl = this.userInfo.photoUrl;
        if (photoUrl != null) {
          return photoUrl.replace("//", "https://").replace("development", "production");
        }
      }
      return "";
    },
  },

  created() {
    this.clientLogo = this.activeUserImg();
  },
};
</script>

<style scoped>
.gw-cab {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}
.gw-cab-identidad {
  min-width: 0;
}
.gw-cab-nombre {
  font-size: 22px;
  font-weight: 700;
  color: #3b3b3b;
  margin: 0 0 3px;
  line-height: 1.25;
}
.gw-cab-persona {
  font-size: 13px;
  color: #9a9a9a;
  margin: 0 0 12px;
}
.gw-cab-estado {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.gw-cab-chip {
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 12px;
}
.gw-cab-chip--curso {
  background: rgba(95, 0, 145, 0.09);
  color: #5f0091;
}
.gw-cab-chip--ok {
  background: #eaf5ef;
  color: #2e7d52;
}
.gw-cab-detalle {
  font-size: 13px;
  color: #6b6b6b;
}
.gw-cab-calidad {
  font-size: 11px;
  font-weight: 600;
  color: #5f0091;
  background: rgba(95, 0, 145, 0.07);
  border-radius: 10px;
  padding: 3px 9px;
  cursor: help;
}
.gw-cab-logo {
  flex-shrink: 0;
}
.gw-cab-logo img {
  max-width: 110px;
  max-height: 56px;
  object-fit: contain;
}
.gw-cab-datos {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #f0f0f0;
}
</style>
